import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ 'template', 'list' ];
  declare readonly templateTarget: HTMLTemplateElement;
  declare readonly listTarget: HTMLElement;
  declare readonly hasListTarget: boolean;

  add(event) {
    event.preventDefault();
    const html = this.templateTarget.innerHTML.replace(
        /__CHILD_INDEX__/g,
        new Date().getTime().toString()
    );

    if (this.hasListTarget) {
      this.listTarget.insertAdjacentHTML('beforeend', html);
    }
    else {
      event.currentTarget.insertAdjacentHTML('beforebegin', html);
    }
  }

  remove(e: Event) {
    const container = (e.currentTarget as HTMLElement).closest('.nested-fields') as HTMLElement;
    if (!container) return;

    const id = (container.querySelector('input.id') as HTMLInputElement)?.value;
    if (id?.length) {
      (container.querySelector('input.destroy') as HTMLInputElement).value = '1';
      container.style.display = 'none';
    } else {
      container.remove();
    }
  }
}
